module.exports = __webpack_public_path__ + "img/KG.d968cd18.svg";